import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  mainStack: {
    paddingTop: 24,
  },
}));
